import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeStatusPajakService = new CrudCustom('/tipe-status-pajaks');
export default TipeStatusPajakService;
